import type { AppRouteKeys } from 'maestro-shared/schema/AppRouteLinks/AppRouteLinks';
import type { ReactElement } from 'react';
import { AdminView } from './views/AdminView/AdminView';
import DashboardView from './views/DashboardView/DashboardView';
import DocumentListView from './views/DocumentListView/DocumentListView';
import DocumentView from './views/DocumentView/DocumentView';
import HomeView from './views/HomeView/HomeView';
import { LaboratoryAgreementsView } from './views/LaboratoryAgreementsView/LaboratoryAgreementsView';
import { LoginCallbackView } from './views/LoginCallbackView/LoginCallbackView';
import { LogoutCallbackView } from './views/LogoutCallbackView/LogoutCallbackView';
import NotificationsView from './views/NotificationsView/NotificationsView';
import { ProgrammingPlanDomainView } from './views/ProgrammingPlanSettingsView/ProgrammingPlanDomainView/ProgrammingPlanDomainView';
import { ProgrammingPlanSettingsView } from './views/ProgrammingPlanSettingsView/ProgrammingPlanSettingsView';
import { ProgrammingPlanView } from './views/ProgrammingPlanSettingsView/ProgrammingPlanView/ProgrammingPlanView';
import ProgrammingView from './views/ProgrammingView/ProgrammingView';
import SampleListView from './views/SampleListView/SampleListView';
import SampleView from './views/SampleView/SampleView';
import { UserListView } from './views/UserListView/UserListView';

export const AppRouteComponents = {
  DashboardRoute: DashboardView,
  NotificationsRoute: NotificationsView,
  ProgrammingRoute: ProgrammingView,
  ProgrammingByYearRoute: ProgrammingView,
  SamplesByYearRoute: SampleListView,
  NewSampleRoute: SampleView,
  SampleRoute: SampleView,
  SampleAnalysisEditRoute: SampleView,
  DocumentsRoute: DocumentListView,
  DocumentRoute: DocumentView,
  NewDocumentRoute: DocumentView,
  LogoutCallbackRoute: LogoutCallbackView,
  LoginRoute: HomeView,
  LoginCallbackRoute: LoginCallbackView,
  AdminRoute: AdminView,
  UsersRoute: UserListView,
  LaboratoryAgreementsRoute: LaboratoryAgreementsView,
  ProgrammingPlanSettingsRoute: ProgrammingPlanSettingsView,
  ProgrammingPlanSettingsDomainRoute: ProgrammingPlanDomainView,
  ProgrammingPlanSettingsPlanRoute: ProgrammingPlanView,
  ProgrammingPlanSettingsSubPlanRoute: ProgrammingPlanView
} as const satisfies Record<AppRouteKeys, () => ReactElement | null>;
